/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2023 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React from 'react';
import SectionData from '../machine/sectionData';

export const DName = (props) => {
  return (
    <div className="row">
      <div className="col-12 col-lg-3" />
      <div className="col-12 col-lg-9">
        <div className="hero-title">
          {!props.iconIsUrl && (props.toggle
            ? <span className={props.iconOnToggleTrue} title={props.titleOnToggleFalse} />
            : <span className={props.iconOnToggleFalse} title={props.titleOnToggleFalse} />)
          }
          {props.iconIsUrl && (props.toggle
            ? <span title={props.titleOnToggleFalse}><img className="icon-image" src={props.iconOnToggleFalse} /></span>
            : <span title={props.titleOnToggleFalse}><img className="icon-image" src={props.iconOnToggleFalse} /></span>)
          }
          <strong>{props.strong}</strong>
          <h2 className="display-3">{props.title}</h2>
        </div>
      </div>
    </div>
  );
};

export const DInfoRects = (props) => {
  return (
    <div className="hero-info">
      {
        props.infos.map(info => info.value && <div key={info.label} className="hero-info-item">
          <span className="label">{info.label}</span>
          <span className="value">{info.value}</span>
        </div>)
      }
    </div>
  );
};

export const DImageAndStatus = (props) => {
  return (
    <div className="row mb-4">
      <div className="col-12 col-lg-3">
        <div className="gallery mb-3 mb-lg-5">
          <img src={props.imgUrl} onError={(error) => { error.target.onerror = null; error.target.src = props.defaultImgUrl; }} alt="" />
          {
            props.children?.[0]
          }
        </div>
      </div>
      {props.children?.[1] && <div className="col-12 col-lg-9">
        <div className="mb-1 mb-md-2 mb-lg-4">
          <h3 className="h5">{props.children?.[1]}</h3>
          <div className="status-timeline">
            {
              props.children?.[2]
            }
          </div>
        </div>
      </div>}
    </div>
  );
};

export const DKeyValueBody = (props) => {
  return (<div className="section">
    <div className="row">
      {
        props.data.map(el => <SectionData key={el.label} eventKey={props.eventKey} cols="col-12 col-sm-6 col-md-4" label={el.label} value={el.value}>
          {el.url && <a href={el.url}>{el.value}</a>}
        </SectionData>)
      }
    </div>
  </div>);
};
